import { FC, } from "react";
import { Button, Col } from "reactstrap";
import { MakeOfferPriceTitle, ScheduleTestDriverTitle } from "../../../../constants";
import { useAppDispatch } from "../../../../reduxToolkit/hooks";
import { setDriverModal, setOfferModal } from "../../../../reduxToolkit/reducers/layoutSlice";
import { CarDetailType } from "../../../../types/Product";
import DriverModal from "../../modals/DriverModal";
import OfferModal from "../../modals/OfferModal";
import ContactInfo from "./ContactInfo";
import Exploration from "./Exploration";
import FeaturedProperty from "./FeaturedProperty";
import Apply from "./Apply";
import OtherOpportunities from "./OtherOpportunities";
import ApplyForJob from "./ApplyForJob";
import KeyJobDetails from "./KeyJobDetails";
import SimilarJobs from "./SimilarJobs";
import ShareFriends from "../../gridView/rightSidebar/ShareFriends";

const DetailSidebar: FC<CarDetailType> = ({ type, sliderStyle }) => {
  const dispatch = useAppDispatch();

  const handleWhatsAppClick = () => {
    window.open("https://wa.me/601162914913", "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {type === "car" ? (
        <>
          <Col lg="3">
            <div className="car-detail-sidebar">
              <div className="sidebar-box">
                <Button className="btn-solid" onClick={() => dispatch(setDriverModal())}>
                  <i className="ri-steering-2-line" /> {ScheduleTestDriverTitle}
                </Button>
                <Button className="btn-border" onClick={handleWhatsAppClick}>
                  <svg
                    style={{marginBottom: 3}}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4c-4.33 0-7.85 3.52-7.85 7.85 0 1.38.36 2.73 1.05 3.92l-1.12 4.07 4.17-1.09a7.85 7.85 0 0 0 3.76.96h.01c4.33 0 7.84-3.52 7.84-7.85 0-2.1-.81-4.07-2.29-5.55zm-5.55 12.05h-.01a6.52 6.52 0 0 1-3.32-.91l-.24-.14-2.47.65.66-2.41-.15-.24a6.52 6.52 0 0 1-1-3.47 6.53 6.53 0 0 1 6.53-6.53c1.74 0 3.38.68 4.61 1.91a6.5 6.5 0 0 1 1.91 4.62c0 3.6-2.93 6.53-6.53 6.53zm3.58-4.89c-.2-.1-1.17-.58-1.35-.64-.18-.06-.32-.1-.45.1-.13.2-.51.64-.63.77-.12.13-.23.15-.43.05-.2-.1-.85-.31-1.62-.99-.6-.53-1-1.19-1.12-1.39-.12-.2-.01-.31.09-.41.09-.09.2-.23.3-.35.1-.12.13-.2.2-.33.07-.13.03-.24-.02-.33-.05-.1-.45-1.08-.62-1.48-.16-.39-.33-.33-.45-.34-.12-.01-.25-.01-.38-.01-.13 0-.34.05-.52.25-.18.2-.68.67-.68 1.63 0 .96.7 1.89.8 2.02.1.13 1.4 2.13 3.39 2.99.47.2.84.32 1.13.41.48.15.91.13 1.25.08.38-.06 1.17-.48 1.33-.94.16-.46.16-.86.11-.94-.05-.08-.19-.13-.39-.23z" />
                  </svg> WhatsApp
                </Button>
              </div>
              <div className="sidebar-box">
                <div className="detail-sub-sidebar">
                  <ContactInfo type={type} />
                  <Exploration type={type} />
                </div>
              </div>
              {/* <div className="sidebar-box">
                <FeaturedProperty type={type} />
              </div> */}
            </div>
          </Col>
          <DriverModal />
          <OfferModal />
        </>
      ) : type === "job" ? (
        <Col lg={sliderStyle === "style_3" ? "5" : "4"} className={sliderStyle === "style_2" || sliderStyle === "style_5" ? "col-xl-3" : ""}>
          <div className={`detail-right-sidebar ${sliderStyle === "style_4" ? "similar-sidebar" : ""}`}>
            {sliderStyle === "style_2" || sliderStyle === "style_5" ? (
              <>
                <ApplyForJob />
                <OtherOpportunities />
                <ShareFriends />
              </>
            ) : sliderStyle === "style_3" ? (
              <>
                <KeyJobDetails />
              </>
            ) : sliderStyle === "style_4" ? (
              <>
                <SimilarJobs />
              </>
            ) : (
              <>
                <Apply />
                <OtherOpportunities />
              </>
            )}
          </div>
        </Col>
      ) : (
        <Col xl="3" lg="4">
          <div className="detail-sidebar">
            <div className="detail-sub-sidebar">
              <ContactInfo />
              <Exploration />
            </div>
            <FeaturedProperty type={type} />
          </div>
        </Col>
      )}
    </>
  );
};

export default DetailSidebar;
